module.exports = __webpack_public_path__ + "static/media/lo5d_post_C.2001aa12.png";